import React from 'react';

const SafePurchase = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-6 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto bg-white shadow-xl rounded-lg overflow-hidden border border-gray-100">
        <div className="p-4 sm:p-12">
          {/* Main Title matches the Terms Page style */}
          <h1 className="text-3xl sm:text-4xl font-extrabold text-gray-900 mb-4 border-b-2 border-gray-200 pb-4">
            Safe Purchase
          </h1>
          
          {/* Date Added Here */}
          <p className="text-sm text-gray-500 mb-8 italic font-medium">
            Update at 10/01/2026
          </p>

          <div className="text-gray-800 space-y-6 leading-relaxed text-base">
            
            {/* Section 1 */}
            <div>
              <h2 className="text-xl font-bold text-gray-900 mb-2">
                Safe & Easy Online Shopping at Regees Tex
              </h2>
              <p>
                At <span className="font-bold">Regees Tex</span>, we are committed to providing a <span className="font-bold">simple, secure, and convenient online shopping experience</span>. Our website is designed to help customers browse and purchase products easily with minimal steps, ensuring a smooth and hassle-free shopping journey.
              </p>
            </div>

            {/* Section 2 */}
            <div>
              <h2 className="text-xl font-bold text-gray-900 mb-2">
                Product Selection & Display
              </h2>
              <p>
                We offer a carefully curated collection of <span className="font-bold">silk sarees and other clothing categories</span>, presented with <span className="font-bold">high-quality zoom and magnified images</span>. This allows customers to closely examine the fabric, design, and detailing, providing an experience similar to shopping in our physical store.
              </p>
            </div>

            {/* Section 3 */}
            <div>
              <h2 className="text-xl font-bold text-gray-900 mb-2">
                Secure Shopping – Our Promise
              </h2>
              <p>
                Payment security is a top priority at <span className="font-bold">Regees Tex</span>. We use <span className="font-bold">Razorpay</span>, a trusted and secure payment gateway in India, to process all online transactions safely and reliably.
              </p>
            </div>

            {/* Section 4 */}
            <div>
              <h2 className="text-xl font-bold text-gray-900 mb-2">
                Advanced Payment Protection
              </h2>
              <p>
                All transactions are protected using <span className="font-bold">SSL (Secure Socket Layer) encryption technology</span>. Your debit card, credit card, UPI, and net banking details are <span className="font-bold">fully encrypted and never stored or shared with the merchant</span>, ensuring protection against unauthorized access or misuse.
              </p>
            </div>

            {/* Conclusion */}
            <p>
              With <span className="font-bold">Regees Tex</span>, customers can shop with <span className="font-bold">confidence, trust, and peace of mind</span>, knowing that every purchase is secured through Razorpay’s industry-standard payment systems.
            </p>

          </div>
        </div>
      </div>
    </div>
  );
};

export default SafePurchase;